import React, {
  FunctionComponent,
  useContext,
  useState,
  FormEvent,
} from "react";
import styles from "./Replies.module.scss";
import CardUser from "shared/components/CardUser/CardUser";
import AppContext from "context/AppContext";

import Collapse from "@material-ui/core/Collapse";

import Button from "shared/components/Buttons/Button";
import apiCalls from "shared/utils/apiCalls";

import ReplyCard from "./Reply/ReplyCard";
import Modal from "shared/components/Modal/Modal";
import ErrorMessage from "shared/components/ErrorMessage/ErrorMessage";
import { Errors } from "shared/types/errors";
import Input from "shared/components/Input/Input";

const Replies: FunctionComponent<{
  replies: any[];
  feedbackId: string;
  getFeedbacks?: any;
}> = ({ replies, getFeedbacks, feedbackId }) => {
  const { state, dispatch } = useContext(AppContext);
  const [reply, setReply] = useState<string>();

  const [replyLoading, setReplyLoading] = useState<boolean>();

  const [
    permissionDeclinedModalOpen,
    setPermissionDeclinedModalOpen,
  ] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!state.user) {
      return;
    }

    if (state.user.reputations < 0) {
      setPermissionDeclinedModalOpen(true);
      return;
    }

    const submit = async () => {
      setReplyLoading(true);

      const res = await apiCalls(
        {
          method: "post",
          data: { content: reply, parentId: feedbackId },
          url: `/reply`,
        },
        dispatch
      );

      const replyId = res?.data.id;

      await apiCalls(
        {
          method: "post",
          data: { replyId },
          url: `/feedbacks/${feedbackId}/replies`,
        },
        dispatch
      );

      await getFeedbacks();

      setReply("");

      setReplyLoading(false);
    };

    submit();
  };

  return (
    <div className={styles.replies}>
      <Modal
        open={permissionDeclinedModalOpen}
        closeModal={() => setPermissionDeclinedModalOpen(false)}
        size="sm"
      >
        <ErrorMessage errorType={Errors.reputationsDeclined} />
      </Modal>

      {replies.map((reply, index) => (
        <React.Fragment key={index}>
          <ReplyCard reply={reply} getFeedbacks={getFeedbacks} />
        </React.Fragment>
      ))}
      {state.user && (
        <form onSubmit={onSubmit}>
          <div className={styles.replies_reply}>
            <CardUser detailsHidden user={state.user} small />

            <div className={styles.replies_reply_userInput}>
              <Input
                name="Reply"
                label="Reply"
                variant="outlined"
                fullWidth
                multiline
                value={reply}
                onChange={(e: any) => setReply(e.target.value)}
              />

              <Collapse in={!!reply}>
                <div className={styles.replies_reply_sendButton}>
                  <Button
                    type="submit"
                    loading={replyLoading}
                    aria-label="submit"
                  >
                    Send
                  </Button>
                </div>
              </Collapse>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default Replies;
